import { Directive, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sdPageLabelClass]',
  standalone: true,
})
export class PageLabelClassDirective implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private currentClass = '';

  @HostBinding('class') get className(): string {
    return this.currentClass;
  }

  constructor(private cmsService: CmsService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (!page) {
          this.currentClass = '';

          return;
        }

        const label = (page.label || page.template || '').trim().toLowerCase().replace(/ /g, '-');

        if (label) {
          const formattedLabel = label.split('/').filter(Boolean).join('-');
          this.currentClass = `page-label-${formattedLabel}`;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
